/**
 * @description Adds a plural suffix if isPlural equals to true
 * @param {string} text - input text
 * @param {number|boolean} isPlural - plural check
 * @return {string} - output text
 * @example
 * //returns 'market'
 * pluralize('market[s]', false);
 *
 * //returns 'companies'
 * pluralize('company[y,ies]', 2);
 *
 * //returns 'men'
 * pluralize('m[a, e]n', true);
 */
export const pluralize = (
    text: string,
    isPlural?: number | boolean,
): string => {
    const replacer = (match: string, matchString: string) => {
        const splittedMatch = matchString.split(',');

        if (typeof isPlural === 'number') {
            isPlural = isPlural !== 1;
        }

        if (isPlural) {
            return splittedMatch[1] || splittedMatch[0];
        } else if (splittedMatch.length === 2) {
            return splittedMatch[0];
        } else {
            return '';
        }
    };

    return text.replace(/\[(.+?)\]/g, replacer);
};
